function outputMimeFor(fileType: string): string {
  if (fileType === "image/png") return "image/png";
  if (fileType === "image/webp") return "image/webp";
  return "image/jpeg";
}

export async function compressImage(
  file: File,
  maxW: number,
  maxH: number,
  quality: number
): Promise<{ dataUrl: string; mime: string }> {
  const mime = outputMimeFor(file.type);
  const hasAlpha = mime === "image/png" || mime === "image/webp";
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(maxW / img.width, maxH / img.height, 1);
      const w = Math.round(img.width * scale);
      const h = Math.round(img.height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) { reject(new Error("canvas unavailable")); return; }
      if (!hasAlpha) {
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, w, h);
      }
      ctx.drawImage(img, 0, 0, w, h);
      resolve({ dataUrl: canvas.toDataURL(mime, hasAlpha ? undefined : quality), mime });
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("failed to load image")); };
    img.src = url;
  });
}
